/**
 * Removes focus from the currently focused element, if there is one.
 *
 * Two common uses:
 * - Release focus from a trigger before focus is moved programmatically — e.g.
 *   so the `v-focus` directive's same-`<form>` steal guard doesn't bail when the
 *   button that triggered the change still holds focus.
 * - Drop focus from an element that is about to be removed — e.g. a toast close
 *   button before the next toast renders.
 *
 * The `instanceof HTMLElement` check narrows by runtime type instead of casting,
 * and naturally no-ops when nothing is focused (`activeElement` is `null` or the
 * `<body>`).
 */
export function blurActiveElement(): void {
  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur();
  }
}
